const ChannelPageShimmer = () => {
  return (
    <>
      <div className="chShimmerCard">
        <div className="chShimmerCardImg shine"></div>
        <div className="chShimmerCardDesc">
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
        </div>
      </div>
      <div className="chShimmerCard">
        <div className="chShimmerCardImg shine"></div>
        <div className="chShimmerCardDesc">
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
        </div>
      </div>
      <div className="chShimmerCard">
        <div className="chShimmerCardImg shine"></div>
        <div className="chShimmerCardDesc">
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
        </div>
      </div>
      <div className="chShimmerCard">
        <div className="chShimmerCardImg shine"></div>
        <div className="chShimmerCardDesc">
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
        </div>
      </div>
      <div className="chShimmerCard">
        <div className="chShimmerCardImg shine"></div>
        <div className="chShimmerCardDesc">
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
        </div>
      </div>
      <div className="chShimmerCard">
        <div className="chShimmerCardImg shine"></div>
        <div className="chShimmerCardDesc">
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
        </div>
      </div>
      <div className="chShimmerCard">
        <div className="chShimmerCardImg shine"></div>
        <div className="chShimmerCardDesc">
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
        </div>
      </div>
      <div className="chShimmerCard">
        <div className="chShimmerCardImg shine"></div>
        <div className="chShimmerCardDesc">
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
        </div>
      </div>
      <div className="chShimmerCard">
        <div className="chShimmerCardImg shine"></div>
        <div className="chShimmerCardDesc">
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
        </div>
      </div>
      <div className="chShimmerCard">
        <div className="chShimmerCardImg shine"></div>
        <div className="chShimmerCardDesc">
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
        </div>
      </div>
      <div className="chShimmerCard">
        <div className="chShimmerCardImg shine"></div>
        <div className="chShimmerCardDesc">
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
        </div>
      </div>
      <div className="chShimmerCard">
        <div className="chShimmerCardImg shine"></div>
        <div className="chShimmerCardDesc">
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
          <div className="chShimmerLines shine"></div>
        </div>
      </div>
    </>
  );
};
export default ChannelPageShimmer;
